import React from 'react';
import useFilterModalContext from '../../useFilterModalContext';
import useSearchParams from '../../../../useSearchParams';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {query, setQuery} = useSearchParams();

  if (!query?.telActivityCount?.from && !query?.telActivityCount?.to) {
    return null;
  }

  const formatRange = () => {
    const {from, to} = query.telActivityCount;
    const hasFrom = from !== null && from !== undefined;
    const hasTo = to !== null && to !== undefined;
    
    if (hasFrom && hasTo) {
      return `${from}〜${to}件`;
    } else if (hasFrom) {
      return `${from}件以上`;
    } else if (hasTo) {
      return `${to}件以下`;
    }
    return '';
  };

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">コールログ件数</h4>
        <button
          onClick={() => setFilterType('telActivityCount')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() =>
            setQuery({...query, telActivityCount: {from: null, to: null}})
          }
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex gap-1">
        <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
          {formatRange()}
        </span>
      </div>
    </div>
  );
};